<div class="relative">
  <div *ngIf="selectedMedia" class="p-5 bg-white grid grid-cols-2 gap-4 justify-content-between">
    <div>
      <h6 class="text-lg font-bold mb-2">
        <span *ngIf="selectedMedia.id">Update image</span>
        <span *ngIf="!selectedMedia.id">Add new image</span>
      </h6>
      <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
          [imageUrl]="selectedMedia.fileURL"
          [progress]="progress" (fileUpdated)="handleFileUpdated($event)"></image-uploader>
    </div>
    <div>
      <div class="form-group">
        <label>Image description</label>
        <input id="desc" class="form-control" placeholder="Enter desc here..."
          [(ngModel)]="selectedMedia.description">
      </div>
      <div class="form-group">
        <label>Search terms (comma separated)</label>
        <input id="desc" class="form-control" placeholder="Enter search terms here..."
          [(ngModel)]="selectedMedia.searchTerms">
      </div>
      
      <div><a [href]="selectedMedia.fileUrl" target="_blank">{{selectedMedia.fileUrl}}</a></div>
      <div>
        <button nbButton size="medium" status="success" class="btn mr-3" (click)="saveMedia()">
          <nb-icon icon="save-outline" pack="eva"></nb-icon> Save
        </button>
        <button nbButton size="medium" status="danger" class="btn" (click)="deleteMedia()">
          <nb-icon icon="save-outline" pack="eva"></nb-icon> Delete
        </button>
      </div>
    </div>
  </div>
  <div class="collection" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="large" nbSpinnerMessage="Loading...">
    <div class="grid grid-cols-6 gap-4" *ngIf="medias">
  
      <div *ngFor="let media of medias; let i = index" class="relative h-auto max-w-full rounded-lg bg-white" (click)="select(media)">
        <img [src]="media.thumbFileURL ? media.thumbFileURL : media.fileURL" *ngIf="media.type !== 'video'" [alt]="media.fileURL">
        <video controls width="100%" preload="metadata" webkit-playsinline playsinline *ngIf="media.type == 'video'">
          <source [src]="media.fileURL" type="video/mp4">
        </video>
        <div class="absolute bottom-0 left-0 right-0 px-4 py-2 bg-gray-800 opacity-70" *ngIf="media.description">
          <!--<h3 class="text-xl text-white font-bold">{{media.description}}</h3>-->
          <p class="mt-2 text-sm text-gray-300">{{media.description}}</p>
        </div>
      </div>
      <h6 *ngIf="medias.length == 0 && !loading" class="ml-4 mt-4">
        No media found
      </h6>
    </div>
  </div>

  
  <button title="Add" (click)="createMedia()"
    class="fixed z-90 bottom-10 right-8 bg-blue-600 w-20 h-20 rounded-full drop-shadow-lg flex justify-center items-center text-white text-4xl hover:bg-blue-700 hover:drop-shadow-2xl hover:animate-bounce duration-300">+</button>

</div>